import { Injectable } from "@angular/core";
import Branch from "../../../core/data/models/branch.model";
import { BaseCrudService } from "../../../core/data/services/base-crud.service";

@Injectable()
export class BranchService extends BaseCrudService<Branch> {
    controller = 'Branchs';

}